import { render, staticRenderFns } from "./DeleteExtraPaymentModal.vue?vue&type=template&id=22c5afb0&"
import script from "./DeleteExtraPaymentModal.vue?vue&type=script&lang=js&"
export * from "./DeleteExtraPaymentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports